import { useEffect, useState } from 'react';
import { withSelect, dispatch } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';
import { throttle } from 'lodash';
import { EmptySvg, HeartFullSvg, IconImportedSVG } from '../../icon';
import { saveDemoLikeState } from '../../helper/axios';
import importer from './importer';
import { applyFilters } from '@wordpress/hooks';
import { Link, useInRouterContext } from 'react-router-dom';

const dataPaging = (data, paging, perPage) => {
    if (perPage) {
        let startIndex = perPage * (paging - 1);
        let result = data.slice(startIndex, startIndex + perPage);
        let totalPage = Math.ceil(data.length / perPage);

        return {
            current: paging,
            data: result,
            total: totalPage,
        };
    } else {
        return {
            current: 1,
            data: data,
            total: 1,
        };
    }
};

const demoFilter = (demoData, filter, selectedCategories) => {
    const { keyword, like, imported } = filter;

    let filteredData = demoData
        .filter(demo => {
            if (!!selectedCategories.length && !selectedCategories.includes('all')) {
                const slugs = demo.data.categories.map(cat => cat.slug);
                return slugs.some(slug => selectedCategories.includes(slug));
            }

            return true;
        })
        .filter((demo) => {
            const { data, like: demoLike, imported: demoImport } = demo;

            if (like) {
                if (false === demoLike) {
                    return false;
                }
            }

            if (imported) {
                if (false === demoImport) {
                    return false;
                }
            }

            if (keyword.length) {
                const { title } = data;
                const wordLowercase = title.toLowerCase();
                return keyword.some(k => wordLowercase.includes(k.toLowerCase()));
            }

            return true;
        });


    return filteredData;
};

const filterDemo = (demoData, filter, selectedCategories, perPage) => {
    const { paging } = filter;

    const data = demoFilter(demoData, filter, selectedCategories).map((demos) => {
        const { id, data, like, imported } = demos;
        const {
            categories,
            cover,
            demo,
            file,
            id: demo_id,
            newFlag,
            pro,
            requirements,
            slug,
            title,
            wordpress_req,
            demo_description,
            order
        } = data;

        return {
            id,
            slug,
            title,
            cover,
            like,
            demo,
            requirements,
            imported,
            newFlag,
            categories,
            file,
            demo_id,
            pro,
            wordpress_req,
            demo_description,
            order
        };
    });
    data.sort(function (a, b) {

        // show imported demo first
        if (a.imported && !b.imported) return -1;
        if (!a.imported && b.imported) return 1;

        // sorting by order field
        const orderA = a.order ?? 0;
        const orderB = b.order ?? 0;
        if (orderA === 0 && orderB !== 0) return 1;
        if (orderA !== 0 && orderB === 0) return -1;

        return orderA - orderB;
    });

    return dataPaging(data, paging, perPage);
};

export const mapId = (data) => {
    const result = {};

    data.map((item) => {
        result[item.id] = item;
    });

    return result;
};

const DemoContentList = (props) => {
    const { demoData, content, dashboardData, setContent, setSnackbar, importab, searchTerm, selectedCategories } = props;
    const data = dashboardData.demoContentData;

    useEffect(() => {
        let demos = demoData;



        const result = filterDemo(demos, data, selectedCategories, 12);
        const { data: newData, total, current } = result;

        setContent(prevState => {
            const { data: oldData } = prevState;
            const theData = data.paging === 1 ? newData : [
                ...oldData,
                ...newData.filter(
                    newItem => !oldData.some(oldItem => oldItem.id === newItem.id)
                )
            ];

            return {
                data: theData,
                total,
                current
            };
        });
    }, [demoData, data, searchTerm, selectedCategories]);

    return <>
        <div className="f-demo-demo-inner">
            {'wizard' !== props.origin && <DemoNavigation importab={importab} setImportab={props.setImportab} search={props.search} setSearch={props.setSearch} />}
            <LayoutContentData
                current={content.current}
                data={content.data}
                total={content.total}
                setSnackbar={setSnackbar}
                importab={importab}
                searchTerm={searchTerm}
                selectedCategories={selectedCategories}
                {...props}
            />
        </div>
    </>;
};

const DemoNavigation = ({ importab, setImportab, search, setSearch, searchSubmi }) => {
    return <div className="demo-navigation-wrapper">
        <div className="f-demo-search-field">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6099 0C10.2533 0 13.2198 2.96641 13.2198 6.60964C13.2198 8.19265 12.6646 9.64347 11.7326 10.7823L17 16.0482L16.0488 17L10.7821 11.7328C9.60581 12.6971 8.13093 13.2226 6.6099 13.2193C2.96652 13.2193 0 10.2529 0 6.60964C0 2.96641 2.96652 0 6.6099 0ZM6.6099 1.32193C3.68171 1.32193 1.32198 3.68157 1.32198 6.60964C1.32198 9.53771 3.68171 11.8974 6.6099 11.8974C9.53808 11.8974 11.8978 9.53771 11.8978 6.60964C11.8978 3.68157 9.53808 1.32193 6.6099 1.32193Z" fill="#9C4DFF" />
            </svg>

            <input
                type="text"
                placeholder={'Search Demo...'}
                value={search}
                onChange={e => setSearch(e.target.value)}
            />
        </div>
        <div className="f-demo-navigation-bottom-wrapper">
            <div className={`f-heading-button tab-all ${importab == 'all' ? 'active' : ''}`} onClick={() => { setImportab('all'); }}>{__('All Demos', 'jkit')}</div>
            <div className={`f-heading-button tab-favorite ${importab == 'favorite' ? 'active' : ''}`} onClick={() => { setImportab('favorite'); }}><HeartFullSvg />{__('Favorite', 'jkit')}</div>
            <div className={`f-heading-button tab-imported ${importab == 'imported' ? 'active' : ''}`} onClick={() => { setImportab('imported'); }}><IconImportedSVG />{__('Imported Demo', 'jkit')}
            </div>
        </div>
    </div>
}

const Paging = (props) => {
    const { current, total, scroller } = props;
    const scrollListener = event => {
        let totalHeight = 20;

        Array.prototype.slice.call(event.target.children).map(child => {
            totalHeight += child.offsetHeight;
        });

        let scrollTop = event.target.scrollTop;
        let wrapperHeight = event.target.offsetHeight;
        let totalScroll = scrollTop + wrapperHeight;

        if (current < total && totalScroll + 500 > totalHeight) {
            dispatch('jkit/dashboard').setPaging(current + 1);
        }
    };

    useEffect(() => {
        if (scroller) {
            const debounceOperation = throttle(scrollListener, 100);

            scroller?.current?.addEventListener('scroll', debounceOperation);

            return () => {
                scroller?.current?.removeEventListener('scroll', debounceOperation);
            };
        }
    });

    return current < total ? <div className="f-demo-paging">
        <div className={classNames('f-demo-paging-button')} onClick={() => {
            dispatch('jkit/dashboard').setPaging(current + 1);
        }}>
            <span>{__('Load More', 'jkit')}</span>
        </div>
    </div> : null;
};

export const LayoutContentData = (props) => {
    const { data, current, total, setSnackbar, importab, searchTerm, selectedCategories } = props;
    //changePaging is sipatch page
    if (data !== undefined) {
        const datas = data.filter(demo => demo !== undefined);
        return datas.length === 0 ? <div className="empty-content">
            <div className="empty-svg">
                <EmptySvg />
            </div>
            <h3>{__('Empty Result', 'jkit')}</h3>
        </div> : <>
            <DemoItem
                data={data}
                setSnackbar={setSnackbar}
                importab={importab}
                searchTerm={searchTerm}
                selectedCategories={selectedCategories}
                {...props}
            />
            <Paging current={current} total={total} />
        </>;
    } else {
        return null;
    }
};

const preprocessText = (text) => {
    const stopwords = [
        'for', 'and', 'the', 'a', 'an', 'to', 'of', 'in', 'on', 'at', 'with',
        'dan', 'yang', 'di', 'ke', 'dari', 'untuk'
    ];

    return text
        .toLowerCase()
        .replace(/[^a-z0-9\u00C0-\u017F\s]/gi, '')
        .split(/\s+/)
        .filter(word => word && !stopwords.includes(word))
        .join(' ');
}

const DemoItem = (props) => {
    const { data, setSnackbar, importab } = props;

    return (
        <div className="demo-items-wrapper layout">
            {data.map(item => (
                <DemoSingleItem
                    key={item.id}
                    item={item}
                    setSnackbar={setSnackbar}
                    importab={importab}
                    {...props}
                />
            ))}
        </div>
    );
};

const DemoSingleItem = (props) => {
    const { item, importab, origin } = props;
    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(true);
    const { proActive } = window['JkitDashboardOption'];
    const { dashboard: dashboardUrl } = window['jkitWizard'] || {};
    const demoPro = '1' === item.pro;
    const userPro = applyFilters('jkit.dashboard.is.pro', false);
    const inRouter = useInRouterContext();
    const upgradeOrActivate = proActive ? (
        inRouter ? (
            <Link
                index="license"
                className='f-demo-import-button f-button-activate-license'
                to={{
                    pathname: '/wp-admin/admin.php',
                    search: '?page=jkit&path=license'
                }}>
                <span>{__('Activate License', 'jkit')}</span>
            </Link>) : (
            <a
                href={dashboardUrl + '&path=license'}
                className="f-demo-import-button f-button-activate-license"
                target="_blank">
                <span>{__('Activate License', 'jkit')}</span>
            </a>)
    ) : (
        <div className={classNames('f-demo-import-button f-button-upgrade')} onClick={() => {
            window.open('https://jegkit.com/pricing/?utm_source=jeg-elementor-kit&utm_medium=dashboard', '_blank');
        }}>
            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8964 2.76916C11.7805 2.65978 11.6368 2.59014 11.4839 2.56917C11.331 2.5482 11.1758 2.57685 11.0381 2.65145L8.76887 3.86916L6.83352 0.406137C6.76419 0.282228 6.66627 0.179718 6.54928 0.108557C6.43229 0.0373956 6.3002 0 6.16583 0C6.03145 0 5.89936 0.0373956 5.78237 0.108557C5.66538 0.179718 5.56747 0.282228 5.49813 0.406137L3.56279 3.86916L1.29311 2.65197C1.15555 2.578 1.00074 2.54951 0.848166 2.57008C0.695594 2.59066 0.552091 2.65938 0.435735 2.76759C0.31938 2.8758 0.235378 3.01866 0.194311 3.17817C0.153245 3.33768 0.156951 3.50671 0.204963 3.66395L1.99516 9.5676C2.02212 9.65654 2.06729 9.73783 2.12733 9.80548C2.18737 9.87312 2.26075 9.92539 2.34206 9.95844C2.42337 9.99148 2.51054 10.0044 2.59713 9.99639C2.68372 9.98833 2.76752 9.95945 2.84236 9.91187C2.85397 9.90458 4.05485 9.16656 6.16486 9.16656C8.27487 9.16656 9.47575 9.90562 9.48494 9.91135C9.55978 9.95955 9.64375 9.98897 9.7306 9.99745C9.81746 10.0059 9.90497 9.99323 9.98664 9.9603C10.0683 9.92738 10.142 9.87507 10.2024 9.80727C10.2627 9.73946 10.308 9.6579 10.335 9.56864L12.1252 3.66812C12.1747 3.51079 12.1793 3.34115 12.1385 3.18097C12.0977 3.0208 12.0134 2.87739 11.8964 2.76916ZM9.43221 8.51656C8.78628 8.24989 7.67443 7.91656 6.16486 7.91656C4.65529 7.91656 3.54343 8.25093 2.89751 8.5176L1.59115 4.20979L3.35861 5.15614C3.53426 5.24945 3.73602 5.26854 3.9241 5.20963C4.11218 5.15072 4.27293 5.0181 4.37466 4.83791L6.16486 1.63531L7.95505 4.83843C8.05678 5.01862 8.21757 5.15121 8.40567 5.21003C8.59378 5.26885 8.79553 5.24962 8.97111 5.15614L10.7381 4.20822L9.43221 8.51656Z" fill="white" />
            </svg>
            <span>{__('PRO', 'jkit')}</span>
        </div>
    );

    const buttonPro = userPro ? (
        <div className={classNames('f-demo-import-button')} onClick={() => {
            importer(item, 'import', origin);
        }}>
            <span>{__('Import Demo', 'jkit')}</span>
        </div>
    ) : upgradeOrActivate;

    useEffect(() => {
        if (animate) {
            setTimeout(() => {
                setAnimate(false);
            }, 300);
        }
    }, [animate]);

    return <div className={`demo-item ${importab} ${visible ? 'visible' : ''}`} key={item.id}>
        <div className="demo-item-detail">
            <div className="demo-title-wrapper">
                <span>
                    {item.title}
                </span>
                {parseInt(item.newFlag) ? <div className="demo-new-flag">{__('NEW', 'jkit')}</div> : ''}
            </div>
            <div className={`demo-like-wrapper ${item.like ? 'active' : ''} ${animate ? 'animate' : ''}`} onClick={() => {
                setAnimate(true);
                setVisible(!item.like);
                setTimeout(() => {
                    likeDemo(item.slug, !item.like);
                }, 300);
            }}>
                <div className={`demo-like ${item.like ? 'active' : ''}`}>
                    <HeartFullSvg size={12} />
                </div>
            </div>
        </div>
        <div className="demo-item-holder">
            <img src={item.cover[0]} />
        </div>
        {item.imported ? <div className="demo-item-button">
            <div className={classNames('f-demo-uninstall-button')} onClick={() => {
                importer(item, 'uninstall', origin);
            }}>
                <span>{__('Uninstall', 'jkit')}</span>
            </div>
        </div> :
            <div className="demo-item-button">
                {demoPro ? buttonPro : <div className={classNames('f-demo-import-button')} onClick={() => {
                    importer(item, 'import', origin);
                }}>
                    <span>{__('Import Demo', 'jkit')}</span>
                </div>}
                <div className={classNames('f-demo-preview-button')} onClick={() => {
                    window.open(item.demo, '_blank');
                }}>
                    <span>{__('Preview', 'jkit')}</span>
                </div>
            </div>}
    </div>;
};

export const likeDemo = (slug, flag) => {
    dispatch('jkit/dashboard').demoLike({
        slug,
        flag
    });
    saveDemoLikeState({
        slug,
        state: flag,
    });
};

const DemoItems = (props) => {
    const [content, setContent] = useState([]);
    const [importab, setImportab] = useState('all');
    const [search, setSearch] = useState('');
    const [selectedCategories, setSelectedCategories] = useState(['all']);

    const { demoCategoryData } = props;
    const placeholder = "Search Demo...";

    useEffect(() => {
        const terms = search.trim().split(/\s+/);
        dispatch('jkit/dashboard').setPaging(1);
        dispatch('jkit/dashboard').setKeyword(terms);

        if (!terms.includes('not-found-term')) {
            setSelectedCategories((prev) => prev.filter((item) => item !== 'all'));
        }
    }, [search]);

    const handleCheckboxChange = (category) => {
        setSelectedCategories((prev) => {
            let next;

            if (category === 'all') {
                next = prev.includes('all') ? [] : ['all'];
            } else {
                next = prev.includes(category)
                    ? prev.filter((item) => item !== category)
                    : [...prev, category];

                next = next.filter((item) => item !== 'all');
            }

            if (next.length === 0) {
                next = ['all'];
            }

            return next;
        });
    };

    useEffect(() => {
        if ('favorite' === importab) {
            dispatch('jkit/dashboard').setLike(true);
            dispatch('jkit/dashboard').setImported(false);
        } else if ('imported' === importab) {
            dispatch('jkit/dashboard').setImported(true);
            dispatch('jkit/dashboard').setLike(false);
        } else {
            dispatch('jkit/dashboard').setImported(false);
            dispatch('jkit/dashboard').setLike(false);
        }
        dispatch('jkit/dashboard').setPaging(1);

    }, [importab]);

    const allChecked = selectedCategories.includes('all');
    return <>
        <div className="f-demo-heading">
            <h2>{__('Import Prebuilt Demos', 'jkit')}</h2>
            <span>{__('Discover 100+ prebuilt demos for you to choose from. Upon import completion, your site will have the exact replica of the showcased site.', 'jkit')}</span>
        </div>
        <div className="f-demo-demo-inner-body">
            <div className="f-filter-sidebar">
                <h3>{__('Category', 'jkit')}</h3>
                <div className="f-filter-sidebar-lists">

                    <div className="checkbox-container" onClick={() => handleCheckboxChange('all')}>
                        {allChecked ? <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" fill="#9C4DFF" stroke="#9C4DFF" />
                                <path d="M11.308 4.22955C11.4738 4.08069 11.6946 3.99839 11.9236 4.00002C12.1527 4.00166 12.3721 4.08709 12.5356 4.23831C12.6991 4.38952 12.7938 4.59468 12.7999 4.81049C12.8059 5.02631 12.7228 5.2359 12.568 5.39505L7.86922 10.9339C7.78842 11.016 7.69091 11.0818 7.5825 11.1275C7.4741 11.1732 7.35703 11.1978 7.2383 11.1999C7.11957 11.2019 7.00161 11.1814 6.89149 11.1395C6.78136 11.0977 6.68133 11.0353 6.59736 10.9561L3.48131 8.01908C3.39453 7.94286 3.32493 7.85096 3.27666 7.74884C3.22838 7.64672 3.20243 7.53648 3.20033 7.4247C3.19824 7.31292 3.22006 7.20189 3.26448 7.09823C3.3089 6.99457 3.37502 6.9004 3.45889 6.82135C3.54276 6.7423 3.64266 6.67998 3.75264 6.63811C3.86262 6.59624 3.98042 6.57567 4.09901 6.57765C4.2176 6.57962 4.33456 6.60408 4.4429 6.64959C4.55125 6.69509 4.64876 6.76069 4.72961 6.84248L7.19561 9.1657L11.2856 4.25397C11.2929 4.24542 11.3008 4.23727 11.3091 4.22955H11.308Z" fill="white" />
                            </svg>
                        </span> :
                            <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="#B5B7C5" />
                                </svg>
                            </span>
                        }
                        <label>
                            <input
                                type="checkbox"
                                value={'all'}
                                checked={selectedCategories.includes('all')}
                                onChange={() => handleCheckboxChange('all')}
                            />
                            {__('All', 'jkit')}
                        </label>
                    </div>
                    {demoCategoryData?.map((category) => {
                        const checked = selectedCategories.includes(category.slug);

                        return (<div key={category.term_id} className="checkbox-container" onClick={() => handleCheckboxChange(category.slug)}>
                            {checked ? <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" fill="#9C4DFF" stroke="#9C4DFF" />
                                    <path d="M11.308 4.22955C11.4738 4.08069 11.6946 3.99839 11.9236 4.00002C12.1527 4.00166 12.3721 4.08709 12.5356 4.23831C12.6991 4.38952 12.7938 4.59468 12.7999 4.81049C12.8059 5.02631 12.7228 5.2359 12.568 5.39505L7.86922 10.9339C7.78842 11.016 7.69091 11.0818 7.5825 11.1275C7.4741 11.1732 7.35703 11.1978 7.2383 11.1999C7.11957 11.2019 7.00161 11.1814 6.89149 11.1395C6.78136 11.0977 6.68133 11.0353 6.59736 10.9561L3.48131 8.01908C3.39453 7.94286 3.32493 7.85096 3.27666 7.74884C3.22838 7.64672 3.20243 7.53648 3.20033 7.4247C3.19824 7.31292 3.22006 7.20189 3.26448 7.09823C3.3089 6.99457 3.37502 6.9004 3.45889 6.82135C3.54276 6.7423 3.64266 6.67998 3.75264 6.63811C3.86262 6.59624 3.98042 6.57567 4.09901 6.57765C4.2176 6.57962 4.33456 6.60408 4.4429 6.64959C4.55125 6.69509 4.64876 6.76069 4.72961 6.84248L7.19561 9.1657L11.2856 4.25397C11.2929 4.24542 11.3008 4.23727 11.3091 4.22955H11.308Z" fill="white" />
                                </svg>
                            </span> :
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="#B5B7C5" />
                                    </svg>
                                </span>}
                            <label>
                                <input
                                    type="checkbox"
                                    value={category.slug}
                                    checked={selectedCategories.includes(category.slug)}
                                    onChange={() => handleCheckboxChange(category.slug)}
                                />
                                {category.name.replace(/&amp;/g, '&')}
                            </label>
                        </div>);
                    })}
                </div>
            </div>
            <DemoContentList {...props}
                content={content}
                setContent={setContent}
                importab={importab}
                selectedCategories={selectedCategories}
                setImportab={setImportab}
                search={search}
                setSearch={setSearch}
            />
        </div>
    </>;
};

export default withSelect(select => {
    const { getDemoData, getDashboardData } = select('jkit/dashboard');

    return {
        demoData: getDemoData().demoData,
        demoCategoryData: getDemoData().demoCategoryData?.terms,
        dashboardData: getDashboardData()
    };
})(DemoItems);
